var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _g4, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 203,
    viewBox: "0 0 208 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.15 197.639C154.603 197.639 195.503 156.739 195.503 106.286C195.503 55.8328 154.603 14.9326 104.15 14.9326C53.6971 14.9326 12.7969 55.8328 12.7969 106.286C12.7969 156.739 53.6971 197.639 104.15 197.639Z",
    fill: "url(#paint0_linear_6799_178556)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.434 36.1875H52.234C45.9261 36.1875 40.8125 41.3011 40.8125 47.609H164.856C164.856 41.3011 159.742 36.1875 153.434 36.1875Z",
    fill: "#4D4DBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8125 47.3008H164.856V141.774C164.856 145.974 163.187 150.003 160.217 152.973C157.247 155.943 153.219 157.611 149.018 157.611H56.6499C52.4496 157.611 48.4213 155.943 45.4512 152.973C42.4811 150.003 40.8125 145.974 40.8125 141.774V47.3008Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 59.2275H62.1733C60.479 59.2275 59.1055 60.5996 59.1055 62.2921C59.1055 63.9846 60.479 65.3567 62.1733 65.3567H143.532C145.226 65.3567 146.6 63.9846 146.6 62.2921C146.6 60.5996 145.226 59.2275 143.532 59.2275Z",
    fill: "url(#paint1_linear_6799_178556)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 85.2686H62.1733C60.479 85.2686 59.1055 86.6406 59.1055 88.3331C59.1055 90.0256 60.479 91.3977 62.1733 91.3977H143.532C145.226 91.3977 146.6 90.0256 146.6 88.3331C146.6 86.6406 145.226 85.2686 143.532 85.2686Z",
    fill: "url(#paint2_linear_6799_178556)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 111.309H62.1733C60.479 111.309 59.1055 112.681 59.1055 114.373C59.1055 116.066 60.479 117.438 62.1733 117.438H143.532C145.226 117.438 146.6 116.066 146.6 114.373C146.6 112.681 145.226 111.309 143.532 111.309Z",
    fill: "url(#paint3_linear_6799_178556)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 137.35H62.1733C60.479 137.35 59.1055 138.722 59.1055 140.414C59.1055 142.107 60.479 143.479 62.1733 143.479H143.532C145.226 143.479 146.6 142.107 146.6 140.414C146.6 138.722 145.226 137.35 143.532 137.35Z",
    fill: "url(#paint4_linear_6799_178556)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6799_178556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6239 105.726H18.3018C14.8214 105.726 12 108.547 12 112.027V173.949C12 177.43 14.8214 180.251 18.3018 180.251H61.6239C65.1042 180.251 67.9256 177.43 67.9256 173.949V112.027C67.9256 108.547 65.1042 105.726 61.6239 105.726Z",
    fill: "url(#paint5_linear_6799_178556)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6799_178556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.947 9H137.096C134.866 9 133.059 10.8076 133.059 13.0374V35.5285C133.059 37.7583 134.866 39.5659 137.096 39.5659H184.947C187.177 39.5659 188.984 37.7583 188.984 35.5285V13.0374C188.984 10.8076 187.177 9 184.947 9Z",
    fill: "url(#paint6_linear_6799_178556)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7915 136.696H23.1378C22.0046 136.696 21.0859 137.615 21.0859 138.748V138.755C21.0859 139.888 22.0046 140.807 23.1378 140.807H56.7915C57.9247 140.807 58.8434 139.888 58.8434 138.755V138.748C58.8434 137.615 57.9247 136.696 56.7915 136.696Z",
    fill: "url(#paint7_linear_6799_178556)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8049 165.623H23.4405C22.317 165.623 21.4062 166.513 21.4062 167.611V167.617C21.4062 168.715 22.317 169.605 23.4405 169.605H56.8049C57.9284 169.605 58.8392 168.715 58.8392 167.617V167.611C58.8392 166.513 57.9284 165.623 56.8049 165.623Z",
    fill: "url(#paint8_linear_6799_178556)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8049 150.491H23.4405C22.317 150.491 21.4062 151.381 21.4062 152.479V152.486C21.4062 153.583 22.317 154.473 23.4405 154.473H56.8049C57.9284 154.473 58.8392 153.583 58.8392 152.486V152.479C58.8392 151.381 57.9284 150.491 56.8049 150.491Z",
    fill: "url(#paint9_linear_6799_178556)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.439 115.289H25.6046C23.4261 115.289 21.6602 117.055 21.6602 119.233V121.963C21.6602 124.141 23.4261 125.907 25.6046 125.907H35.439C37.6175 125.907 39.3834 124.141 39.3834 121.963V119.233C39.3834 117.055 37.6175 115.289 35.439 115.289Z",
    fill: "url(#paint10_linear_6799_178556)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.868 28.923C147.432 28.923 149.51 26.8448 149.51 24.2813C149.51 21.7178 147.432 19.6396 144.868 19.6396C142.305 19.6396 140.227 21.7178 140.227 24.2813C140.227 26.8448 142.305 28.923 144.868 28.923Z",
    fill: "#4D4DBE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.454 28.923C164.018 28.923 166.096 26.8448 166.096 24.2813C166.096 21.7178 164.018 19.6396 161.454 19.6396C158.891 19.6396 156.812 21.7178 156.812 24.2813C156.812 26.8448 158.891 28.923 161.454 28.923Z",
    fill: "#4D4DBE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.044 28.923C180.608 28.923 182.686 26.8448 182.686 24.2813C182.686 21.7178 180.608 19.6396 178.044 19.6396C175.48 19.6396 173.402 21.7178 173.402 24.2813C173.402 26.8448 175.48 28.923 178.044 28.923Z",
    fill: "#4D4DBE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.459 139.628L153.703 152.588L186.839 182.644L198.595 169.684L165.459 139.628Z",
    fill: "#4D4DBE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.881 118.182C177.881 145.296 155.901 167.275 128.788 167.275C101.675 167.275 79.6953 145.296 79.6953 118.182C79.6953 91.0694 101.675 69.0898 128.788 69.0898C155.901 69.0898 177.881 91.0694 177.881 118.182ZM170.351 118.18C170.351 141.134 151.743 159.742 128.789 159.742C105.835 159.742 87.2266 141.134 87.2266 118.18C87.2266 95.2253 105.835 76.6172 128.789 76.6172C151.743 76.6172 170.351 95.2253 170.351 118.18Z",
    fill: "#4D4DBE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_6799_178556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.789 159.74C151.743 159.74 170.351 141.132 170.351 118.178C170.351 95.2234 151.743 76.6152 128.789 76.6152C105.835 76.6152 87.2266 95.2234 87.2266 118.178C87.2266 141.132 105.835 159.74 128.789 159.74Z",
    fill: "url(#paint11_linear_6799_178556)",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6799_178556)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.163,
    cy: 141.135,
    rx: 29.2179,
    ry: 4.31627,
    fill: "#EC5575",
    fillOpacity: 0.56
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M186.836 182.646L198.592 169.686L200.362 171.292C202.08 172.851 203.109 175.028 203.222 177.344C203.335 179.661 202.523 181.928 200.964 183.646C199.406 185.364 197.229 186.392 194.912 186.505C192.596 186.618 190.329 185.806 188.611 184.248L186.84 182.642L186.836 182.646Z",
    fill: "#4D4DBE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6799_178556",
    x: 0,
    y: 97.7256,
    width: 85.9258,
    height: 104.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6799_178556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6799_178556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6799_178556",
    x: 126.059,
    y: 0,
    width: 81.9258,
    height: 56.5659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6799_178556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6799_178556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_6799_178556",
    x: 70.5514,
    y: 59.9401,
    width: 116.475,
    height: 116.475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.33757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6799_178556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6799_178556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6799_178556",
    x: 80.1014,
    y: 115.974,
    width: 100.123,
    height: 50.3202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.422,
    result: "effect1_foregroundBlur_6799_178556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6799_178556",
    x1: 103.446,
    y1: -14.8142,
    x2: 105.317,
    y2: 306.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4DBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6799_178556",
    x1: 55.405,
    y1: 65.1039,
    x2: 151.775,
    y2: 65.1039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6799_178556",
    x1: 55.405,
    y1: 91.1449,
    x2: 151.775,
    y2: 91.1449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6799_178556",
    x1: 55.405,
    y1: 117.185,
    x2: 151.775,
    y2: 117.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6799_178556",
    x1: 55.405,
    y1: 143.226,
    x2: 151.775,
    y2: 143.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6799_178556",
    x1: 10.3208,
    y1: 161.611,
    x2: 117.512,
    y2: 170.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6799_178556",
    x1: 131.379,
    y1: 31.9207,
    x2: 212.131,
    y2: 34.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6799_178556",
    x1: 63.2252,
    y1: 140.929,
    x2: 17.8278,
    y2: 140.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4DBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6799_178556",
    x1: 63.1834,
    y1: 169.724,
    x2: 18.1761,
    y2: 169.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4DBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6799_178556",
    x1: 63.1834,
    y1: 154.592,
    x2: 18.1761,
    y2: 154.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4DBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6799_178556",
    x1: 51.6732,
    y1: 125.805,
    x2: 19.4171,
    y2: 125.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243799,
    stopColor: "#CACAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4DBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6799_178556",
    x1: 128.789,
    y1: 76.6152,
    x2: 170.67,
    y2: 185.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoFillIcon);
export default __webpack_public_path__ + "static/media/auto-fill-icon.5cbfb42a7ab6feda268ca8fa2499a881.svg";
export { ForwardRef as ReactComponent };